// L-K

 (function() {
    var sel = [
      '.boom-launcher',
      '.loloyal-launcher-wrapper',
      '.loloyal-launcher-box',
      '#loloyal-launcher-box',
      '.loloyal-iframe-page',
      '[class*="loloyal-launcher"]',
      '[class*="boom-launcher"]'
    ].join(', ');

    function hide() {
      if (window.innerWidth > 768) return;
      document.querySelectorAll(sel).forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
      });
    }
    hide();
    new MutationObserver(hide).observe(document.documentElement, {childList: true, subtree: true});
    window.addEventListener('resize', hide);
  })();

  (function() {
    var divStyle = [
      'position:absolute',
      'left:0',
      'top:1px',
      'bottom:1px',
      'width:1px',
      'background:#bbb',
      'pointer-events:none',
      'z-index:10',
      'border-radius:0',
      'display:block'
    ].join(';');

    function addDividers() {
      var links = document.querySelectorAll('.mobile-sticky-bar__wrapper .mobile-sticky-bar__link');
      if (!links.length) return;
      var show = window.innerWidth <= 1023.98;
      links.forEach(function(el, i) {
        var existing = el.querySelector('.custom-divider');
        if (i === 0 || !show) {
          if (existing) existing.remove();
          return;
        }
        el.style.position = 'relative';
        el.style.overflow = 'visible';
        if (existing) return;
        var line = document.createElement('span');
        line.className = 'custom-divider';
        line.style.cssText = divStyle;
        el.appendChild(line);
      });
    }
    addDividers();
    new MutationObserver(addDividers).observe(document.body, {childList: true, subtree: true});
    window.addEventListener('resize', addDividers);
  })();
  